import React from 'react';
import { CTALink, Row, Image, ActivityIndicator } from 'modules/styled';

import imgIcon from 'public/img/icons/img-icon.png';

interface ImageButtonProps {
  isDragActive?: boolean;
  uploading: boolean;
  noText: boolean;
}

export const ImageButton = ({
  isDragActive,
  uploading,
  noText,
}: ImageButtonProps): JSX.Element => (
  <Row
    sx={{
      margin: 'auto',
      variant: 'cursor',
    }}
  >
    {noText && uploading ? null : (
      <Image
        resizeMode="contain"
        sx={{ mr: 3.001, width: 14, height: 14 }}
        source={imgIcon}
      />
    )}
    {uploading ? (
      <Uploading noText={noText} />
    ) : noText ? null : (
      <CTALink sx={{ color: 'black' }}>
        {isDragActive ? 'Drop image here ...' : 'Add Image'}
      </CTALink>
    )}
  </Row>
);

const Uploading = ({ noText }: { noText: boolean }) => (
  <Row>
    {noText ? null : (
      <CTALink sx={{ color: 'black', mr: 3.001 }}>Uploading Images...</CTALink>
    )}
    <ActivityIndicator />
  </Row>
);
